var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useState } from 'react';
import { useSurveysQuery } from 'apollo/queries/SURVEYS';
import useDebouncedFunction from 'utils/hooks/useDebouncedFunction';
import { cursorFetchMore, getPageInfo } from 'utils/paginationHelper';
import { FIRST_25_VARIABLES } from 'constants/pagination';
import { NODES_PATH } from 'constants/dataPaths';
var dataPath = ['surveys'];
var useSurveySelect = function () {
    var _a;
    var _b = useState(''), search = _b[0], setSearch = _b[1];
    var _c = useSurveysQuery({
        variables: __assign({ search: search }, FIRST_25_VARIABLES)
    }), data = _c.data, loading = _c.loading, fetchMore = _c.fetchMore;
    var rawOptions = ((_a = data === null || data === void 0 ? void 0 : data.surveys) === null || _a === void 0 ? void 0 : _a.nodes) || [];
    var options = rawOptions.map(function (_a) {
        var id = _a.id, title = _a.title;
        return ({
            key: id,
            value: id,
            label: title
        });
    });
    var handleSearch = useCallback(function (v) {
        if (v === '' || (v && v.length >= 3)) {
            setSearch(v);
        }
    }, []);
    var debouncedSearch = useDebouncedFunction(handleSearch, 1000);
    var onPopupScroll = function (event) {
        var target = event.target;
        if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            var pageInfo = getPageInfo(dataPath)(data);
            if (!pageInfo.hasNextPage)
                return;
            cursorFetchMore(fetchMore)({
                dataPath: dataPath,
                dataType: NODES_PATH,
                pageInfo: pageInfo
            });
        }
    };
    return {
        data: {
            loading: loading,
            options: options
        },
        functions: {
            debouncedSearch: debouncedSearch,
            onPopupScroll: onPopupScroll
        }
    };
};
export default useSurveySelect;
